import { render, staticRenderFns } from "./position_info.vue?vue&type=template&id=7320893c&scoped=true"
import script from "./position_info.vue?vue&type=script&lang=js"
export * from "./position_info.vue?vue&type=script&lang=js"
import style0 from "./position_info.vue?vue&type=style&index=0&id=7320893c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320893c",
  null
  
)

export default component.exports